<template>
    <div>
     <figure class="image-compare"  @mousemove.prevent="onMouseMove" @touchstart="onMouseMove($event, true)" @touchmove="onMouseMove($event, true)" @click="onMouseMove($event, true)">
        <div class="image-compare-wrapper" :style="{ width: posX + 'px' }">
            <vue-load-image>
                <img slot="image"  :src="after" :width="width" :height="height" :style="dimensions">
                <div slot="preloader" class="image-loading-container image-loading-container-white" :style="dimensions"><div><b-spinner label="Loading..." ></b-spinner></div></div>
                <div slot="error"  class="screenshot-error" :style="dimensions">
                    <div>Cannot load screenshot<p> <i class="fa fa-warning"></i></p></div></div>
            </vue-load-image>

            <div v-if="highlight" :class="{'active-animatioon': true, 'animation-active': boxesBefore.length < animationThreshold, changeBox: true, changeBoxNew: change.type === 'new', changeBoxText: change.type === 'text'}" v-for="change in boxesAfter" :style="{position: 'absolute', top: `${change.y}px`, left: `${change.x}px`, width: `${change.width}px`, height: `${change.height}px`}">
            </div>
        </div>
        <vue-load-image>
            <img slot="image" :src="before" :width="width" :height="height" :style="dimensions">
            <div slot="preloader" class="image-loading-container image-loading-container-white" :style="dimensions"><div><b-spinner label="Loading..." ></b-spinner></div></div>
            <div slot="error"  class="screenshot-error" :style="dimensions">
                <div>Cannot load screenshot<p> <i class="fa fa-warning"></i></p></div></div>
        </vue-load-image>
        <div v-if="highlight" :class="{'active-animatioon': true,'animation-active': boxesBefore.length < animationThreshold, changeBox: true, changeBoxNew: change.type === 'new', changeBoxText: change.type === 'text'}" v-for="change in boxesBefore" :style="{ position: 'absolute', top: `${change.y}px`, left: `${change.x}px`, width: `${change.width}px`, height: `${change.height}px`}">
        </div>

        <div class="image-compare-handle" :style="{ left: posX + 'px' }" @mousedown.prevent="onMouseDown">
      <span class="image-compare-handle-icon left">
        <slot name="icon-left"></slot>
      </span>
            <span class="image-compare-handle-icon right">
        <slot name="icon-right"></slot>
      </span>
        </div>
    </figure>
    </div>
</template>

<script>
  import VueLoadImage from 'vue-load-image'
  export default {
    components: {  'vue-load-image': VueLoadImage},
    props: {
      before: {
        type: String,
        required: true
      },
      after: {
        type: String,
        required: true
      },
      highlight:{
        type: Boolean,
        default: true,
      },
      boxesBefore: {
        type: Array,
        default: function(){ return []}
      },
      boxesAfter: {
        type: Array,
        default: function(){ return []}
      },
      width: {
        type: Number,
        default: 300
      },
      height: {
        type: Number,
        default: 300
      },
      padding: {
        type: Object,
        default() {
          return {
            left: 0,
            right: 0
          }
        },
        required: false
      },
    },
    data() {
      return {
        animationThreshold: 20,
        pageX: null,
        posX: null,
        isDragging: false,
        allowNextFrame: true,
        unwatch: null
      }
    },
    computed: {
      dimensions() {
        return {
          width: `${this.width}px`,
          height:`${this.height}px`
        }
      }
    },
    methods: {
      onResize() {
        // this.width = this.$el.clientWidth;
        // this.height = this.$el.clientHeight;
        this.setInitialPosX(this.padding.left + this.padding.right);
      },
      onMouseDown() {
        this.isDragging = true;
      },
      onMouseUp(event) {
        event.preventDefault();
        this.isDragging = false;
      },
      onMouseMove(event, isDragging = this.isDragging) {
        if (isDragging && this.allowNextFrame) {
          this.allowNextFrame = false;
          this.pageX = event.pageX || event.targetTouches[0].pageX || event.originalEvent.targetTouches[0].pageX;
          window.requestAnimationFrame(this.updatePos);
        }
      },
      updatePos() {
        let posX = this.pageX - this.$el.getBoundingClientRect().left;
        if (posX < this.padding.left) {
          posX = this.padding.left;
        } else if (posX > this.width - this.padding.right) {
          posX = this.width - this.padding.right;
        }
        this.posX = posX;
        this.allowNextFrame = true;
      },
      setInitialPosX(padding) {
        if (padding >= this.width) {
          return;
        }
        this.posX = (this.width + this.padding.left - this.padding.right) / 2;
      }
    },
    created() {
      window.addEventListener('mouseup', this.onMouseUp);
      window.addEventListener('resize', this.onResize);
    },
    mounted() {
      this.onResize();
      this.unwatch = this.$watch(
        () => this.padding.left + this.padding.right,
        (newValue) => this.setInitialPosX(newValue)
      );
    },
    beforeDestroy() {
      this.unwatch();
      window.removeEventListener('mouseup', this.onMouseUp);
      window.removeEventListener('resize', this.onResize);
    }
  };
</script>

<style lang="scss" scoped>
    .image-compare {
        position: relative;
        margin: 0;
        img {
            max-width: none;
            display: block;
        }
    }
    .image-compare-wrapper,
    .image-compare-handle {
        bottom: 0;
        position: absolute;
        top: 0;
    }
    .image-compare-wrapper {
        left: 0;
        overflow: hidden;
        width: 100%;
        z-index: 1;
        transform: translateZ(0);
        will-change: width;
    }
    .image-compare-handle {
        color: red;
        background-color: currentColor;
        cursor: ew-resize;
        transform: translateX(-50%) translateZ(0);
        width: 4px;
        z-index: 2;
        will-change: left;
    }
    .image-compare-handle-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        font-size: 4rem;
        color: currentColor;
        line-height: normal;
        &.left {
            padding-right: 10px;
            transform: translate(-100%, -50%);
        }
        &.right {
            padding-left: 10px;
            transform: translate(0, -50%);
        }
    }
</style>
